import React from "react";
import { safeJsonParse } from "../utilityFunctions/stringUtility";
import SelectComponent from "../../components/UniversalComponents/SelectComponent";
import {
  buildOptionsFromListCustomer,
  buildOptionsFromListCustomDashboard,
  findFirstKey,
} from "../utilityFunctions/CustomerReactTable/CustomerUtility";

export function DebouncedInput({ value: initialValue, onChange, debounce = 400, ...props }) {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, debounce, onChange]);

  return <input {...props} value={value} onChange={(e) => setValue(e.target.value)} autoFocus />;
}

export default function Filter({
  column,
  visibleRows,
  isMySpace,
  isCustomModule,
  generateUniqueValues,
  useGenerateUniqueValues,
  useBuildOptionsFromList,
  buildOptionsFromList,
}) {
  const { filterVariant, type } = column.columnDef.meta ?? {};
  const columnFilterValue = column.getFilterValue();

  const sortedUniqueValues = React.useMemo(() => {
    //for fields like delegation and assigned_to

    let keys = Array.from(column.getFacetedUniqueValues().keys()).filter((key) => key !== null);

    console.log("keys before generateUniqueValues", keys);

    if (useGenerateUniqueValues) {
      const uniqueValues = generateUniqueValues(keys);
      console.log("uniqueValues riyal", uniqueValues);
      return uniqueValues;
    }

    return keys.sort().slice(0, 5000);
  }, [column.getFacetedUniqueValues(), filterVariant, column.id]);

  return useGenerateUniqueValues && useBuildOptionsFromList ? (
    <>
      <div>
        <SelectComponent
          name={column.id}
          options={buildOptionsFromList(sortedUniqueValues, ["value", "textForUrl", "email"])}
          multiSelect
          showSearch
          noChildren
          onChange={(e) => {
            console.log("selected value in 1", e.target.value);
            column.setFilterValue(safeJsonParse(e.target.value));
          }}
          value={
            buildOptionsFromList(columnFilterValue, ["value", "textForUrl", "email"])
            // ?.map((entry) => {
            //   try {
            //     const parsed = safeJsonParse(entry);

            //     if (typeof parsed === "object" && parsed !== null) {
            //       const found = findFirstKey(parsed, ["value", "textForUrl", "email"]);
            //       if (found !== undefined && found !== null) {
            //         return { label: found, value: entry };
            //       }
            //     }

            //     // fallback
            //     return { label: String(entry), value: entry };
            //   } catch (e) {
            //     return { label: String(entry), value: entry };
            //   }
            // }) ?? ""
          }
          size="small"
          showCheckBox
        ></SelectComponent>
      </div>
    </>
  ) : (
    <div>
      <SelectComponent
        name={column.id}
        options={buildOptionsFromListCustomer(sortedUniqueValues, ["value", "textForUrl", "email"])}
        multiSelect
        showSearch
        noChildren
        onChange={(e) => {
          console.log("selected value", e.target.value);
          column.setFilterValue(safeJsonParse(e.target.value));
        }}
        value={
          columnFilterValue?.map((entry) => {
            try {
              const parsed = safeJsonParse(entry);

              if (typeof parsed === "object" && parsed !== null) {
                const found = findFirstKey(parsed, ["value", "textForUrl", "email"]);
                if (found !== undefined && found !== null) {
                  return { label: found, value: entry };
                }
              }

              // fallback
              return { label: String(entry), value: entry };
            } catch (e) {
              return { label: String(entry), value: entry };
            }
          }) ?? ""
        }
        size="small"
        showCheckBox
      ></SelectComponent>
    </div>
  );
}
